import React, { forwardRef } from 'react';

import styled from 'styled-components';

const Svg = styled.svg`
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
`;

export type SearchIconProps = Omit<
  React.SVGProps<SVGSVGElement>,
  'color' | 'ref'
> & {
  size?: string | number;
  color?: string;
};

export const SearchIcon = forwardRef<SVGSVGElement, SearchIconProps>(
  ({ size = '20', color = 'currentColor', ...rest }, ref) => (
    <Svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      focusable="false"
      aria-hidden="true"
      {...rest}
    >
      <circle
        cx="10.75"
        cy="10.75"
        r="7.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m16.1 16.1 4.4 4.4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  ),
);

SearchIcon.displayName = 'SearchIcon';
